import React from 'react';
interface PlayerFrameProps {
  children: React.ReactNode;
}

/**
 * Interactive-video player shell: a 16:9 canvas on a neutral page, the way the
 * teaser is actually distributed. Portrait-ish on small screens so the story
 * stays legible on a phone.
 */
export function PlayerFrame({
  children
}: PlayerFrameProps) {
  return <div className="flex min-h-screen w-full items-center justify-center bg-neutral-200 px-3 py-6 md:px-8" data-id="element-159" data-mp="39c6iy0bai1ly">
      <div className="w-full max-w-[1040px]" data-id="element-160" data-mp="34fg41gb81c24">
        <div className="relative aspect-[3/4] w-full overflow-hidden rounded-xl bg-solventum-bg shadow-2xl sm:aspect-[4/3] md:aspect-video" data-id="element-161" data-mp="30cjibgqdwzty">
          {children}
        </div>
      </div>
    </div>;
}